/**
 * Shared brand design tokens — the code-level mirror of DESIGN_SYSTEM.md §1 ("Fable" palette,
 * which is law). Web reads these; the mobile app (C:\deploy\mobile) mirrors the SAME values so the
 * two clients match. Keep in lockstep with the `--f-*` CSS vars in globals.css and DESIGN_SYSTEM.md
 * — this file is the single JS/TS source for both platforms.
 */
export const brand = {
  // Dark band bases
  navy: '#0B132B',
  navy2: '#101A38',
  navyDeep: '#08111F',

  // Primary green
  green: '#0E7C61',
  greenDeep: '#0A5C49',
  greenDark: '#083D32',

  // Live / accent
  teal: '#14B8A6',
  emerald: '#34D399',

  // Sacred gold
  gold: '#D4AF37',
  goldDeep: '#B8932B',
  goldSoft: '#E6C963',

  danger: '#E5674B',
  beige: '#F6F4EE',
} as const

/** Text + surface roles on the dark navy band (DESIGN_SYSTEM §1 "On dark navy"). */
export const onDark = {
  text: '#F3F5FA',
  body: 'rgba(246,244,238,.80)',
  micro: '#8A94A8',
  panel: 'linear-gradient(180deg, #111E3A, #0D1830)',
  panelSoft: 'linear-gradient(180deg, #0F1A34, #0B1730)',
  line: 'rgba(148,163,184,.14)',
  lineGold: 'rgba(212,175,55,.24)',
  lineTeal: 'rgba(20,184,166,.24)',
  lineDanger: 'rgba(229,103,75,.42)',
} as const

/** Ordered segment palette for donut/legend categories. */
export const segColors = ['#14B8A6', '#D4AF37', '#0E7C61', '#5B8DEF', '#B084E8', '#8A94A8'] as const

/** Gradients (DESIGN_SYSTEM §5). */
export const gradients = {
  greenBtn: 'linear-gradient(135deg, #0E7C61, #0A5C49)',
  goldBtn: 'linear-gradient(135deg, #D4AF37, #B8932B)',
  progress: 'linear-gradient(90deg, #0E7C61, #14B8A6)',
  darkBand:
    'radial-gradient(720px 440px at 22% 18%, rgba(14,124,97,.16), transparent 62%),' +
    'radial-gradient(620px 420px at 92% 8%, rgba(212,175,55,.08), transparent 60%),' +
    'linear-gradient(170deg, #101A38, #0B132B)',
} as const
